import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { stripe } from '@/config';
import { useCountries } from '@/hooks/useCountries';
import { useMemo } from 'react';

type StripeElementLocale = NonNullable<
    React.ComponentProps<typeof Elements>['options']
>['locale'];

export default function StripeElements({
    children,
    countryCode,
}: {
    children: React.ReactNode;
    countryCode: string;
}): JSX.Element {
    const countries = useCountries();
    const country = countries[countryCode] ?? countries['GB'];

    const stripePromise = useMemo(
        () => loadStripe(`${country.iso_code === 'US' ? stripe.keyUS : stripe.key}`),
        [country],
    );

    return (
        <Elements
            stripe={stripePromise}
            options={{ locale: country.locale as StripeElementLocale }}>
            {children}
        </Elements>
    );
}
